import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-171" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-172" data-mp="o3xb3cmzv1ct">
        <SectionHeading id="summary-title" data-id="element-173" data-mp="j887my7ut0b8">Everything <span className="text-fiber" data-id="element-174" data-mp="j5c7r4cg41k5">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-line bg-navy-900 sm:grid-cols-2" data-id="element-175" data-mp="1gufao3oieklh">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-line p-4 sm:odd:border-r" data-id="element-176" data-mp="16wrauzc1qmwg">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-fiber" data-id="element-177" data-mp="12vfulkf2be0x">
                <CheckIcon className="h-3.5 w-3.5 text-navy-950" aria-hidden="true" data-id="element-178" data-mp="3rni5fu4pnjd7" />
              </span>
              <span className="text-sm font-medium text-white" data-id="element-179" data-mp="3nl57vt04arri">{feature}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}